import { useState, useEffect } from 'react'
import { FiChevronDown, FiChevronRight, FiMaximize, FiMinimize, FiX } from 'react-icons/fi'
import api from '../utils/api'

const formatNumber = (v) => {
  if (v == null || isNaN(v)) return ''
  return Number(v).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

const getTableSizes = () => {
  const fnt = (typeof localStorage !== 'undefined' && localStorage.getItem('tableFontSize')) || 'md'
  // Dashboard CSS zoom altında küçük fontlar bulanıklaşıyor → biraz büyük + antialiased
  return {
    font: fnt === 'sm' ? 'text-[11px]' : fnt === 'lg' ? 'text-[14px]' : 'text-[12.5px]',
  }
}

// Pocan istasyon etiketi/rengi (backend BUYUK HARF gonderebilir, normalize)
const ISTASYON_LABEL = (s) => {
  const x = (s || '').toLocaleLowerCase('tr-TR').replace(/ı/g, 'i')
  if (x.includes('altin')) return 'Altınekin'
  if (x.includes('tatli')) return 'Tatlıcak'
  if (x.includes('ladik')) return 'Ladık'
  return s || ''
}
const ISTASYON_COLOR = (s) => {
  const x = (s || '').toLocaleLowerCase('tr-TR').replace(/ı/g, 'i')
  if (x.includes('altin')) return 'text-blue-600 dark:text-blue-400'
  if (x.includes('tatli')) return 'text-emerald-600 dark:text-emerald-400'
  if (x.includes('ladik')) return 'text-amber-600 dark:text-amber-400'
  return 'text-gray-500 dark:text-gray-400'
}
const ZAMAN_ONCE = (iso) => {
  if (!iso) return ''
  const t = new Date(iso)
  if (isNaN(t.getTime())) return ''
  const dk = Math.floor((Date.now() - t.getTime()) / 60000)
  if (dk < 1) return 'az önce'
  if (dk < 60) return `${dk} dk önce`
  const sa = Math.floor(dk / 60)
  if (sa < 24) return `${sa} sa önce`
  return t.toLocaleDateString('tr-TR')
}

const POCAN_DS = [6, 9, 11]

export default function CariDetayPanel() {
  const [selectedCari, setSelectedCari] = useState(null)
  const [datasourceId, setDatasourceId] = useState(6)
  const [hareketler, setHareketler] = useState([])
  const [devir, setDevir] = useState(0)
  const [ozet, setOzet] = useState(null)
  const [guncelleme, setGuncelleme] = useState(null)
  const [loading, setLoading] = useState(false)
  const [tarihBas, setTarihBas] = useState('')
  const [tarihBit, setTarihBit] = useState('')
  const [turFilter, setTurFilter] = useState('')
  const [sortDir, setSortDir] = useState('desc')
  const [expanded, setExpanded] = useState({})
  const [fullscreen, setFullscreen] = useState(false)

  // Diger widget'lardan event dinle (toggle: ayni cariye tekrar tikla -> kapat)
  useEffect(() => {
    const handler = (e) => {
      const { BLCARI, UNVAN, datasourceId: dsId } = e.detail || {}
      if (!BLCARI || !UNVAN) return
      setSelectedCari(prev => {
        if (prev && prev.BLCARI === BLCARI) {
          setHareketler([]); setDevir(0); setOzet(null)
          return null
        }
        if (dsId) setDatasourceId(dsId)
        return { BLCARI, UNVAN }
      })
    }
    const closeHandler = () => { setSelectedCari(null); setHareketler([]); setDevir(0); setOzet(null) }
    window.addEventListener('cari-selected', handler)
    window.addEventListener('cari-detay-close', closeHandler)
    return () => {
      window.removeEventListener('cari-selected', handler)
      window.removeEventListener('cari-detay-close', closeHandler)
    }
  }, [])

  // Detay yukle — Pocan istasyonu (6/9/11) ise 3 istasyon birlesik (tum), yoksa tek istasyon (blcari)
  useEffect(() => {
    if (!selectedCari) return
    setLoading(true)
    const isPocan = POCAN_DS.includes(Number(datasourceId))
    const params = new URLSearchParams()
    if (tarihBas) params.set('tarih_bas', tarihBas)
    if (tarihBit) params.set('tarih_bit', tarihBit)
    // UNVAN her zaman query param (unvan_q) — path'teki nokta/ozel karakter IIS'te 404'e yol aciyor
    let url
    if (isPocan) {
      params.set('tum', 'true')
      params.set('unvan_q', selectedCari.UNVAN)
      url = `/cari-detay/_?${params.toString()}`
    } else {
      params.set('datasource_id', datasourceId)
      params.set('blcari', selectedCari.BLCARI)
      url = `/cari-detay/_?${params.toString()}`
    }
    api.get(url)
      .then(({ data }) => {
        setHareketler(data.data || [])
        setDevir(data.devir_bakiye || 0)
        setOzet(data.istasyon_ozet || null)
        setGuncelleme(data.guncelleme || null)
      })
      .catch(() => { setHareketler([]); setDevir(0); setOzet(null); setGuncelleme(null) })
      .finally(() => setLoading(false))
  }, [selectedCari, datasourceId, tarihBas, tarihBit])

  if (!selectedCari) return null

  const hasIstasyon = hareketler.some(h => h.ISTASYON)

  // Tur filtre + sort
  const filteredByTur = turFilter ? hareketler.filter(h => h.ISLEM_TURU === turFilter) : hareketler
  const sorted = [...filteredByTur].sort((a, b) => sortDir === 'desc'
    ? String(b.TARIH || '').localeCompare(String(a.TARIH || ''))
    : String(a.TARIH || '').localeCompare(String(b.TARIH || '')))

  // Bakiye kolonlari (her satir):
  //  _CUM   = KUMULATIF (onceki donem devri DAHIL, genel bakiye)
  //  _DONEM = DONEM (devirsiz, secili donem icinde yuruyen bakiye)
  // Backend her satir icin KUMULATIF_BAKIYE + DONEM_BAKIYE dondurur; yoksa frontend hesaplar.
  // Kumulatif (Genel) HER ZAMAN gosterilir (oncekileri toplayan birikimli bakiye).
  // Bakiye (Donem) SADECE tarih filtresi secilince gosterilir (o filtre araligindaki bakiye).
  const donemAktif = !!(tarihBas || tarihBit)
  const hasBackendBakiye = filteredByTur.length > 0 && filteredByTur[0].KUMULATIF_BAKIYE !== undefined
  let withCum
  if (hasBackendBakiye) {
    withCum = sorted.map(r => ({ ...r, _CUM: Number(r.KUMULATIF_BAKIYE) || 0, _DONEM: Number(r.DONEM_BAKIYE ?? r.KUMULATIF_BAKIYE) || 0 }))
  } else {
    const chronological = [...filteredByTur].sort((a, b) => String(a.TARIH || '').localeCompare(String(b.TARIH || '')))
    let cum = devir, don = 0
    const cumMap = new Map(), donMap = new Map()
    chronological.forEach(r => { const net = (r.BORC || 0) - (r.ALACAK || 0); cum += net; don += net; cumMap.set(r, cum); donMap.set(r, don) })
    withCum = sorted.map(r => ({ ...r, _CUM: cumMap.get(r) || 0, _DONEM: donMap.get(r) || 0 }))
  }

  const groupYilAy = (arr) => {
    const g = {}
    arr.forEach(r => {
      const t = String(r.TARIH || '').substring(0, 10)
      const yil = t.substring(0, 4) || '?'
      const ay = t.substring(0, 7) || '?'
      if (!g[yil]) g[yil] = {}
      if (!g[yil][ay]) g[yil][ay] = []
      g[yil][ay].push(r)
    })
    return g
  }
  const groupedByIst = hasIstasyon
    ? withCum.reduce((acc, r) => { const k = r.ISTASYON || '?'; (acc[k] = acc[k] || []).push(r); return acc }, {})
    : null
  const grouped = hasIstasyon ? null : groupYilAy(withCum)

  const turler = [...new Set(hareketler.map(h => h.ISLEM_TURU).filter(Boolean))].sort()
  const turColor = (t) => {
    const s = (t || '').toLowerCase()
    return s.includes('tahsilat') || s.includes('posgelir') ? 'text-green-600' : s.includes('aln') ? 'text-blue-600' : s.includes('sat') || s.includes('borc') ? 'text-orange-600' : s.includes('virman') ? 'text-purple-600' : 'text-gray-600'
  }
  const ayAd = (ay) => ['', 'Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'][parseInt(ay.split('-')[1]) || 0] || ay
  const toggleC = (k) => setExpanded(p => ({ ...p, [k]: !p[k] }))

  const closePanel = () => {
    setSelectedCari(null); setHareketler([]); setDevir(0); setOzet(null)
    window.dispatchEvent(new CustomEvent('cari-detay-close'))
  }

  const exportFile = async (format) => {
    try {
      const rows = withCum.map(r => ({
        Tarih: String(r.TARIH || '').substring(0, 10),
        ...(hasIstasyon ? { Istasyon: ISTASYON_LABEL(r.ISTASYON) } : {}),
        'Islem Turu': r.ISLEM_TURU,
        Borc: r.BORC || 0,
        Alacak: r.ALACAK || 0,
        'Bakiye (Donem)': r._DONEM || 0,
        'Kumulatif (Genel)': r._CUM || 0,
        Aciklama: r.ACIKLAMA || ''
      }))
      const token = localStorage.getItem('token')
      const resp = await fetch(`/api/export/${format}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({
          data: rows,
          filename: `${selectedCari.UNVAN}_hareket`,
          title: `${selectedCari.UNVAN} - Cari Hareketler`
        })
      })
      if (!resp.ok) return
      const blob = await resp.blob()
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a'); a.href = url; a.download = `${selectedCari.UNVAN}_hareket.${format}`; a.click()
      URL.revokeObjectURL(url)
    } catch (e) { console.error('Export hatasi:', e) }
  }

  // Yil/Ay agacini render (prefix ile benzersiz collapse key)
  const renderYilAy = (yilAyGrouped, prefix) =>
    Object.entries(yilAyGrouped).sort(([a], [b]) => sortDir === 'desc' ? b.localeCompare(a) : a.localeCompare(b)).flatMap(([yil, aylar]) => {
      const yk = `${prefix}${yil}`
      const yC = !expanded[yk]
      const yRows = Object.values(aylar).flat()
      const yB = yRows.reduce((s, r) => s + (r.BORC || 0), 0)
      const yA = yRows.reduce((s, r) => s + (r.ALACAK || 0), 0)
      // Yil sonu birikimli bakiye = o yilin EN YENI hareketinin kumulatifi
      const yKumul = yRows.length ? [...yRows].sort((a, b) => String(a.TARIH || '').localeCompare(String(b.TARIH || ''))).slice(-1)[0]._CUM || 0 : 0
      const out = []
      out.push(
        <tr key={`y-${yk}`} className="bg-slate-200 dark:bg-slate-700 cursor-pointer hover:bg-slate-300 dark:hover:bg-slate-600" onClick={() => toggleC(yk)}>
          <td className="px-1 text-center">{yC ? <FiChevronRight size={11} /> : <FiChevronDown size={11} />}</td>
          <td className="px-2 py-1 font-bold text-slate-700 dark:text-slate-200" colSpan={2}>{yil} ({yRows.length})</td>
          <td className="px-2 py-1 text-right font-bold text-red-600">{formatNumber(yB)}</td>
          <td className="px-2 py-1 text-right font-bold text-green-600">{formatNumber(yA)}</td>
          {donemAktif && <td className={`px-2 py-1 text-right font-bold ${yB - yA > 0 ? 'text-red-700' : 'text-green-700'}`}>{formatNumber(yB - yA)}</td>}
          <td className={`px-2 py-1 text-right font-bold ${yKumul > 0 ? 'text-red-700' : 'text-green-700'}`}>{formatNumber(yKumul)}</td>
          <td></td>
        </tr>
      )
      if (!yC) {
        Object.entries(aylar).sort(([a], [b]) => sortDir === 'desc' ? b.localeCompare(a) : a.localeCompare(b)).forEach(([ay, rows]) => {
          const aK = `${yk}-${ay}`; const aC = !expanded[aK]
          const aB = rows.reduce((s, r) => s + (r.BORC || 0), 0); const aA = rows.reduce((s, r) => s + (r.ALACAK || 0), 0)
          // Ay sonu birikimli bakiye = o ayin EN YENI hareketinin kumulatifi
          const aKumul = rows.length ? [...rows].sort((a, b) => String(a.TARIH || '').localeCompare(String(b.TARIH || ''))).slice(-1)[0]._CUM || 0 : 0
          out.push(
            <tr key={`m-${aK}`} className="bg-gray-50 dark:bg-gray-700/50 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700" onClick={() => toggleC(aK)}>
              <td className="pl-4 text-center">{aC ? <FiChevronRight size={10} /> : <FiChevronDown size={10} />}</td>
              <td className="px-2 py-0.5 font-semibold text-gray-600 dark:text-gray-300 pl-4" colSpan={2}>{ayAd(ay)} ({rows.length})</td>
              <td className="px-2 py-0.5 text-right text-red-500 font-medium">{formatNumber(aB)}</td>
              <td className="px-2 py-0.5 text-right text-green-500 font-medium">{formatNumber(aA)}</td>
              {donemAktif && <td className={`px-2 py-0.5 text-right font-medium ${aB - aA > 0 ? 'text-red-600' : 'text-green-600'}`}>{formatNumber(aB - aA)}</td>}
              <td className={`px-2 py-0.5 text-right font-medium ${aKumul > 0 ? 'text-red-600' : 'text-green-600'}`}>{formatNumber(aKumul)}</td>
              <td></td>
            </tr>
          )
          if (!aC) {
            const _ayRows = [...rows].sort((a, b) => sortDir === 'desc'
              ? String(b.TARIH || '').localeCompare(String(a.TARIH || ''))
              : String(a.TARIH || '').localeCompare(String(b.TARIH || '')))
            _ayRows.forEach((r, i) => {
              out.push(
                <tr key={`r-${aK}-${i}`} className="border-b border-gray-50 dark:border-gray-700 hover:bg-blue-50/30 dark:hover:bg-blue-900/20">
                  <td></td>
                  <td className="px-2 py-0.5 pl-6 whitespace-nowrap">{String(r.TARIH || '').substring(0, 10)}</td>
                  <td className={`px-2 py-0.5 font-medium truncate ${turColor(r.ISLEM_TURU)}`}>{r.ISLEM_TURU}</td>
                  <td className="px-2 py-0.5 text-right tabular-nums text-red-600">{r.BORC > 0 ? formatNumber(r.BORC) : ''}</td>
                  <td className="px-2 py-0.5 text-right tabular-nums text-green-600">{r.ALACAK > 0 ? formatNumber(r.ALACAK) : ''}</td>
                  {donemAktif && <td className={`px-2 py-0.5 text-right tabular-nums ${r._DONEM > 0 ? 'text-red-500' : 'text-green-500'}`}>{formatNumber(r._DONEM)}</td>}
                  <td className={`px-2 py-0.5 text-right tabular-nums font-medium ${r._CUM > 0 ? 'text-red-700' : 'text-green-700'}`}>{formatNumber(r._CUM)}</td>
                  <td className="px-2 py-0.5 truncate text-gray-500 dark:text-gray-400" title={r.ACIKLAMA || ''}>{r.ACIKLAMA}</td>
                </tr>
              )
            })
          }
        })
      }
      return out
    })

  const wrapperClass = fullscreen
    ? 'fixed inset-4 z-50 bg-white dark:bg-gray-800 rounded-xl shadow-2xl flex flex-col overflow-hidden'
    : 'bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-100 dark:border-gray-700 mt-2 flex flex-col overflow-hidden'
  const tableHeight = fullscreen ? 'flex-1' : 'max-h-[75vh] min-h-[500px]'

  return (
    <div className={wrapperClass}>
      <div className="bg-slate-700 dark:bg-slate-900 text-white px-3 py-1.5 flex items-center gap-2 flex-wrap flex-shrink-0">
        <span className="text-xs font-medium">{selectedCari.UNVAN} — {filteredByTur.length} hareket</span>
        {guncelleme && <span className="text-[9px] px-1.5 py-0.5 rounded bg-white/10 text-white/70" title="Cari hareket anlik goruntusu (snapshot) bu zamanda guncellendi">🕐 {ZAMAN_ONCE(guncelleme)}</span>}
        {!hasIstasyon && devir !== 0 && <span className={`text-[10px] px-1.5 py-0.5 rounded ${devir > 0 ? 'bg-red-500/30' : 'bg-green-500/30'}`}>Devir: {formatNumber(devir)}</span>}
        <div className="ml-auto flex items-center gap-1">
          <input type="date" value={tarihBas} onChange={e => setTarihBas(e.target.value)} className="text-[10px] bg-white/10 border border-white/20 rounded px-1 py-0.5 text-white w-28" />
          <span className="text-[10px]">-</span>
          <input type="date" value={tarihBit} onChange={e => setTarihBit(e.target.value)} className="text-[10px] bg-white/10 border border-white/20 rounded px-1 py-0.5 text-white w-28" />
          {(tarihBas || tarihBit) && <button onClick={() => { setTarihBas(''); setTarihBit('') }} className="text-[10px] text-white/50 hover:text-white">Temizle</button>}
          <select value={turFilter} onChange={e => setTurFilter(e.target.value)} className="text-[10px] bg-white/10 border border-white/20 rounded px-1.5 py-0.5 text-white">
            <option value="">Tum Turler</option>
            {turler.map(t => <option key={t} value={t}>{t}</option>)}
          </select>
          <button onClick={() => setSortDir(d => d === 'desc' ? 'asc' : 'desc')} className="text-[10px] bg-white/10 border border-white/20 rounded px-1.5 py-0.5 text-white">
            {sortDir === 'desc' ? 'Yeni→Eski' : 'Eski→Yeni'}
          </button>
          <button onClick={() => exportFile('xlsx')} className="text-[10px] bg-green-500/30 hover:bg-green-500/50 rounded px-1.5 py-0.5 text-white" title="Excel olarak indir">Excel</button>
          <button onClick={() => exportFile('pdf')} className="text-[10px] bg-red-500/30 hover:bg-red-500/50 rounded px-1.5 py-0.5 text-white" title="PDF olarak indir">PDF</button>
          <button onClick={() => setFullscreen(f => !f)} className="text-white/70 hover:text-white p-0.5" title={fullscreen ? 'Kucult' : 'Tam ekran'}>
            {fullscreen ? <FiMinimize size={13} /> : <FiMaximize size={13} />}
          </button>
          <button onClick={closePanel} className="text-white/70 hover:text-white p-0.5"><FiX size={14} /></button>
        </div>
      </div>

      {/* Istasyon bazli bakiye ozeti (tum mod) — her istasyon + toplam */}
      {hasIstasyon && ozet && ozet.length > 0 && (
        <div className="flex flex-wrap items-stretch gap-1.5 px-3 py-2 bg-slate-100 dark:bg-gray-700/40 border-b border-slate-200 dark:border-gray-700 flex-shrink-0">
          {ozet.map(o => {
            const donemB = (o.bakiye || 0) - (o.devir || 0)   // dönem = devirsiz
            return (
            <div key={o.istasyon} className={`flex flex-col px-2.5 py-1 rounded border min-w-[140px] ${o.hata ? 'bg-red-50 border-red-200 dark:bg-red-900/20' : 'bg-white dark:bg-gray-800 border-slate-200 dark:border-gray-600'}`}>
              <span className={`text-[10px] font-semibold ${ISTASYON_COLOR(o.istasyon)}`}>{ISTASYON_LABEL(o.istasyon)}</span>
              {o.hata ? (
                <span className="text-[10px] font-medium text-red-500">erişilemedi</span>
              ) : (
                <>
                  <div className="flex items-baseline justify-between gap-2">
                    <span className="text-[9px] text-gray-400">Dönem</span>
                    <span className={`text-xs font-medium tabular-nums ${donemB > 0 ? 'text-red-600 dark:text-red-400' : donemB < 0 ? 'text-green-600 dark:text-green-400' : 'text-gray-500'}`}>{formatNumber(donemB)}</span>
                  </div>
                  <div className="flex items-baseline justify-between gap-2 border-t border-gray-200 dark:border-gray-600 mt-0.5 pt-0.5">
                    <span className="text-[9px] text-gray-400">Genel</span>
                    <span className={`text-sm font-bold tabular-nums ${o.bakiye > 0 ? 'text-red-700 dark:text-red-400' : o.bakiye < 0 ? 'text-green-700 dark:text-green-400' : 'text-gray-500'}`}>{formatNumber(o.bakiye)}</span>
                  </div>
                  <span className="text-[9px] text-gray-400 mt-0.5">{o.hareket} hareket</span>
                </>
              )}
            </div>
          )})}
          {(() => {
            const tB = ozet.reduce((s, o) => s + (o.bakiye || 0), 0)
            const tD = ozet.reduce((s, o) => s + ((o.bakiye || 0) - (o.devir || 0)), 0)
            const tH = ozet.reduce((s, o) => s + (o.hareket || 0), 0)
            return (
              <div className="flex flex-col px-2.5 py-1 rounded bg-slate-700 dark:bg-slate-900 text-white min-w-[140px]">
                <span className="text-[10px] font-semibold">TOPLAM</span>
                <div className="flex items-baseline justify-between gap-2">
                  <span className="text-[9px] text-white/60">Dönem</span>
                  <span className="text-xs font-medium tabular-nums">{formatNumber(tD)}</span>
                </div>
                <div className="flex items-baseline justify-between gap-2 border-t border-white/20 mt-0.5 pt-0.5">
                  <span className="text-[9px] text-white/60">Genel</span>
                  <span className="text-sm font-bold tabular-nums">{formatNumber(tB)}</span>
                </div>
                <span className="text-[9px] text-white/60 mt-0.5">{tH} hareket</span>
              </div>
            )
          })()}
        </div>
      )}

      <div className={`overflow-auto ${tableHeight}`}>
        {loading ? (
          <div className="p-6 text-center text-gray-400 dark:text-gray-500 text-xs">Yukleniyor...</div>
        ) : hareketler.length === 0 ? (
          <div className="p-6 text-center text-gray-400 dark:text-gray-500 text-xs">Hareket bulunamadi</div>
        ) : (
          <table className={`w-full ${getTableSizes().font} table-fixed antialiased [&_td]:py-[3px] [&_th]:py-[3px] leading-snug`}>
            <colgroup>
              <col style={{ width: '28px' }} />
              <col style={{ width: '110px' }} />
              <col style={{ width: '140px' }} />
              <col style={{ width: '115px' }} />
              <col style={{ width: '115px' }} />
              {donemAktif && <col style={{ width: '130px' }} />}
              <col style={{ width: '135px' }} />
              <col />
            </colgroup>
            <thead className="sticky top-0 z-10">
              <tr className="bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300">
                <th className="px-1"></th>
                <th className="text-left px-2 py-1 font-medium">Tarih</th>
                <th className="text-left px-2 py-1 font-medium">Islem Turu</th>
                <th className="text-right px-2 py-1 font-medium">Borc</th>
                <th className="text-right px-2 py-1 font-medium">Alacak</th>
                {donemAktif && <th className="text-right px-2 py-1 font-medium" title="Secili filtre araligindaki bakiye (devir haric)">Bakiye (Donem)</th>}
                <th className="text-right px-2 py-1 font-medium" title="Oncekileri toplayan birikimli genel bakiye">Kumulatif (Genel)</th>
                <th className="text-left px-2 py-1 font-medium">Aciklama</th>
              </tr>
            </thead>
            <tbody>
              {/* Acilis/devir satiri — HER ZAMAN en ustte (onceki donemden gelen baslangic bakiyesi) */}
              {(() => {
                const toplamDevir = hasIstasyon ? (ozet || []).reduce((s, o) => s + (o.devir || 0), 0) : devir
                return (
                  <tr className="bg-amber-50 dark:bg-amber-900/20 border-b-2 border-amber-300 font-bold">
                    <td></td>
                    <td className="px-2 py-1 text-amber-800 dark:text-amber-200" colSpan={2}>DEVIR BAKIYE</td>
                    <td className="px-2 py-1 text-right text-red-600">{toplamDevir > 0 ? formatNumber(toplamDevir) : ''}</td>
                    <td className="px-2 py-1 text-right text-green-600">{toplamDevir < 0 ? formatNumber(Math.abs(toplamDevir)) : ''}</td>
                    {donemAktif && <td className="px-2 py-1 text-right text-gray-400">-</td>}
                    <td className={`px-2 py-1 text-right ${toplamDevir > 0 ? 'text-red-700' : toplamDevir < 0 ? 'text-green-700' : 'text-gray-500'}`}>{formatNumber(toplamDevir)}</td>
                    <td className="px-2 py-1 text-[10px] text-amber-600 truncate">Onceki donemden gelen</td>
                  </tr>
                )
              })()}
              {hasIstasyon
                ? Object.entries(groupedByIst).sort(([a], [b]) => ISTASYON_LABEL(a).localeCompare(ISTASYON_LABEL(b), 'tr')).flatMap(([ist, rows]) => {
                    const ik = `IST::${ist}`
                    const iC = !expanded[ik]
                    const o = (ozet || []).find(x => ISTASYON_LABEL(x.istasyon) === ISTASYON_LABEL(ist))
                    const iB = o ? o.borc : rows.reduce((s, r) => s + (r.BORC || 0), 0)
                    const iA = o ? o.alacak : rows.reduce((s, r) => s + (r.ALACAK || 0), 0)
                    const iBak = o ? o.bakiye : (iB - iA)
                    const iDev = o ? o.devir : 0
                    const head = (
                      <tr key={`ist-${ik}`} className={`cursor-pointer border-b border-slate-300 dark:border-slate-600 ${iC ? 'bg-slate-300/60 dark:bg-slate-700' : 'bg-slate-300 dark:bg-slate-600'} hover:bg-slate-400/40`} onClick={() => toggleC(ik)}>
                        <td className="px-1 text-center">{iC ? <FiChevronRight size={12} /> : <FiChevronDown size={12} />}</td>
                        <td className="px-2 py-1 font-bold" colSpan={2}>
                          <span className={ISTASYON_COLOR(ist)}>● </span>
                          <span className="text-slate-800 dark:text-slate-100">{ISTASYON_LABEL(ist)}</span>
                          <span className="text-slate-500 dark:text-slate-400 font-normal"> ({rows.length} hareket{iDev ? ` · devir ${formatNumber(iDev)}` : ''})</span>
                        </td>
                        <td className="px-2 py-1 text-right font-bold text-red-600">{formatNumber(iB)}</td>
                        <td className="px-2 py-1 text-right font-bold text-green-600">{formatNumber(iA)}</td>
                        {donemAktif && <td className={`px-2 py-1 text-right font-semibold ${(iBak - iDev) > 0 ? 'text-red-500' : 'text-green-500'}`}>{formatNumber(iBak - iDev)}</td>}
                        <td className={`px-2 py-1 text-right font-bold ${iBak > 0 ? 'text-red-700' : 'text-green-700'}`}>{formatNumber(iBak)}</td>
                        <td></td>
                      </tr>
                    )
                    return iC ? [head] : [head, ...renderYilAy(groupYilAy(rows), `${ik}::`)]
                  })
                : renderYilAy(grouped, '')}
            </tbody>
          </table>
        )}
      </div>
    </div>
  )
}
